import { EVENTS } from "../APIs/APIs";
import update from "immutability-helper";
import initialState from "../reducers/initialState";

const UserInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS.SET_USER_AUTHENTICATION:
      return update(state, {
        isAuthenticated: {
          $set: action.data,
        },
      });
    case EVENTS.SET_USER_TOKEN:
      return update(state, {
        token: {
          $set: action.data,
        },
      });

    case EVENTS.SET_USER_REFRESH_TOKEN:
      return update(state, {
        refreshToken: {
          $set: action.data,
        },
      });
    case EVENTS.SET_USER_INFO:
      return update(state, {
        userInfo: {
          $set: action.data,
        },
      });
    case EVENTS.LOGIN_HAS_ERRORS:
      return update(state, {
        loginHasErr: {
          $set: action.data,
        },
      });
    case EVENTS.LOGIN_IN_PROGRESS:
      return update(state, {
        loginInProgress: {
          $set: action.data,
        },
      });
    //*********** REFRESH TOKEN *************//

    case EVENTS.INVALID_TOKEN:
      return {
        ...state,
        tokenIsValid: false,
        pendingRefreshingToken: false,
      };

    case EVENTS.REFRESHING_TOKEN:
      return {
        ...state,
        pendingRefreshingToken: true,
        tokenIsValid: false,
      };
    case EVENTS.TOKEN_REFRESHED:
      return {
        ...state,
        pendingRefreshingToken: null,
        tokenIsValid: true,
      };
    //************Password*****************//
    case EVENTS.CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        changePasswordModal: !state.changePasswordModal,
      };

    //************Language*****************//
    case EVENTS.UPDATE_USER_LANGUAGE:
      return {
        ...state,
        language: action.data,
      };

    default:
      return state;
  }
};
export default UserInfoReducer;
